import React from 'react';
import { useSelector, useDispatch } from 'react-redux'
import {
	CRow,CCol,
	CForm,CFormInput,CFormSelect,//CFormTextarea,CInputGroup,CInputGroupText,CButton,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import { isMobile } from "react-device-detect";
import { MyButton } from './index';
import { UFunc } from "../helpers/functions";
import PropTypes from 'prop-types';
import {
	MyDialogform,
} from '../components/index'

const pjson 	= require('../../package.json')
const MyDialogbarangregister = props => {
	const { 
		show, toggle, onSimpan, 
		setLoading, prosesExpired, showToast, setSessionaktif,
		...rest 
	} = props;

	//--REDUX_ROUTER--/
	const uDispatch 			= useDispatch();
	//--END REDUX_ROUTER--/

	const uEfekapp				= useSelector(state => state.effectApp);
	const uBahasaObj			= useSelector(state => state.listBahasa);
	const uTokenObj				= JSON.parse(localStorage.getItem("token")||"{}");

	const [uDatajenisArr,setDatajenisArr]		= React.useState([])
	const [uISSimpantriggered,setSimpantriggered]	= React.useState(false)

	//--DLG_FORM--/
	const [uISDlgformshow,setDlgformshow]	= React.useState(false)
	const [uDlgformObj,setDlgformObj]		= React.useState({})
	//--END DLG_FORM--/

	//--DOM--/
	//--END DOM--/

	//--HANDEL--/
	const hdlKlikDlgformsimpan = () => {
		//--VALIDASI--/
		let vElfocus = document.getElementById("inpbarangregisternama");
		if((uDlgformObj.nama_barang||"").trim() === "") {
			vElfocus && vElfocus.focus();
			showToast("Nama Barang Harus Diisi !"); return;
		}

		if((uDlgformObj.nama_barang||"").length < 3) {
			vElfocus && vElfocus.focus();
			showToast("Nama Barang Tidak Valid (Min: 3 Karakter) !"); return;
		}
		vElfocus = document.getElementById("inpbarangregisterjenis");
		if((parseInt(uDlgformObj.jenis_id)||0) <= 0) {
			vElfocus && vElfocus.focus();
			showToast("Jenis Barang Harus Dipilih !"); return;
		}
		//--END VALIDASI--/

		const vArridx = UFunc.getObjectIndeks(uDatajenisArr,uDlgformObj.jenis_id);

		//--DISPATCH_SIMPAN--/
		const vTmpObj = {
			nama_barang: uDlgformObj.nama_barang,
			kode_barang: (uDlgformObj.kode_barang||"").toUpperCase(),
			jenis_caption: (uDatajenisArr[vArridx]||{}).jenis_barang || "Undf Jenis",
			jenis_id: (parseInt(uDlgformObj.jenis_id)||0),
			timestamp: Math.floor(Math.random() * (Date.now())),
		}
		uDispatch({type: "set", gBarangregistered: vTmpObj});
		//--END DISPATCH_SIMPAN--/

		setSimpantriggered(true);
	}
	//--END HANDEL--/

	//--FUNCTION_PROCEDURE--/
	//--END FUNCTION_PROCEDURE--/

	//--CONTENT--/
	const contentDlgform = () => {
		if(!show) return (<></>)//>

		return (
		<CForm>
		<CRow className="my-2">
			<CCol xs="12">Nama Barang</CCol>
			<CCol>
				<CFormInput size="sm" maxLength={100} autoComplete="off"
					value={uDlgformObj.nama_barang||""}
					onChange={(e)=>setDlgformObj({...uDlgformObj,nama_barang:e.target.value})}
					id="inpbarangregisternama"/>
			</CCol>
		</CRow>

		<div className="my-3 classborderbottom"/>
			<div className="classpetunjuk">
			*) Register Barang Baru, Akan Disimpan setelah Input Transaksi TERSIMPAN.
			</div>
		<div className="my-3 classborderbottom"/>
		
		<CRow className="my-2">
			<CCol xs="4">Kode Barang</CCol>
			<CCol>
				<CFormInput size="sm" maxLength={50} autoComplete="off"
					className="text-uppercase"
					value={uDlgformObj.kode_barang||""}
					onChange={(e)=>setDlgformObj({...uDlgformObj,kode_barang:e.target.value})}
					id="inpbarangregisterkode"/>
			</CCol>
		</CRow>
		
		<CRow className="my-2">
			<CCol xs="4">Jenis Barang</CCol>
			<CCol>
				<CFormSelect size="sm"
					value={uDlgformObj.jenis_id}
					onChange={(e)=>setDlgformObj({...uDlgformObj,jenis_id:e.target.value})}
					onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
					id="inpbarangregisterjenis">
				{uDatajenisArr.map((vItems,vKeys)=>{
					return (
					<option key={vKeys} value={vItems.id}>
					{(vItems.jenis_barang||"").toUpperCase()}
					</option>
					)//>
				})}
				</CFormSelect>
			</CCol>
		</CRow>
		</CForm>
		)//>
	}
	//--END CONTENT--/

	//--API--/
	const apiLoadawal = () => {
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			setLoading(false);
		},2500); return;
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api2/api_init/ld_jenisbarang";

		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); } })
		.then((output_string) => {
			setSessionaktif(true)
			setLoading(false);
			if(output_string.tampil) {
				//console.log("(Requestorder - apiLoaddetil) vTabelid : "+vTabelid);
				const vDataarr 	= JSON.parse(output_string.datajenis || "[]");
				setDatajenisArr(vDataarr);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(MyDialogbarangregister - apiLoadawal) output_string.errors : "+output_string.errors);
				const vMsg 	= (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired();
			}
		})
		.catch((error) =>{
			setLoading(false);
			console.log("(MyDialogbarangregister - apiLoadawal) catch-error: "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	//--END API--/

	//--EFFECT--/
	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});

		apiLoadawal();

		return () => {
			setLoading(false); toggle();
			setDatajenisArr([]);
			setSimpantriggered(false);
			uDispatch({type: "set", gBarangregistered: undefined});
		}
	},[])
	React.useEffect(()=>{
		if(!show) { setDlgformObj({}); return }

		setDlgformObj({
			jenis_id: parseInt((uDatajenisArr[0]||{}).id)||0,
		})

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			const vElfocus = document.getElementById("inpbarangregisternama");

			if(!isMobile)
				vElfocus && vElfocus.focus();
		},300)
	},[show])
	React.useEffect(()=>{
		if(!uISSimpantriggered) return
		setSimpantriggered(false);

		onSimpan()
	},[uISSimpantriggered])
	//--END EFFECT--/

	return (
	<MyDialogform
		options={{centered:true}}
		onSimpan={()=>hdlKlikDlgformsimpan()}
		show={show} 
		dialogHeader="Register Master Barang"
		toggle={toggle}
		renderContent={contentDlgform()}
		id="iddialogformbarang"/>
	)//>
}

export default MyDialogbarangregister;